import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import type { Api } from "./lib/api";
import { DemoApi } from "./lib/demoApi";
import { SupabaseApi } from "./lib/supabaseApi";
import { SessionProvider } from "./app/session";
import { ToastProvider } from "./app/ui";
import "./styles.css";

// Demo mode (`npm run demo`, or ?demo in the address) uses made-up data and never contacts a server.
function makeApi(): Api {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as
    | string
    | undefined;
  const demo = import.meta.env.MODE === "demo" ||
    new URLSearchParams(window.location.search).has("demo") || !url || !key;
  return demo ? new DemoApi() : new SupabaseApi(url!, key!);
}

// Facebook sends the owner back to /integrations with its answer in the address (D-148), the address its app knows;
// the dashboard's pages live after the #, so the answer moves to Facebook's own page (D-156) before anything reads it.
if (window.location.pathname.replace(/\/+$/, "") === "/integrations") {
  const q = new URLSearchParams(window.location.search);
  const facebook = q.has("code") || q.has("error");
  window.history.replaceState(
    null,
    "",
    `/#/integrations${facebook ? "/facebook-lead-ads" : ""}${window.location.search}`,
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ToastProvider>
      <SessionProvider api={makeApi()}>
        <App />
      </SessionProvider>
    </ToastProvider>
  </StrictMode>,
);
